module.exports = __webpack_public_path__ + "assets/material-qr.svg";